.formCreator {
  &__wrapper {
    z-index: 1000;
    background-color: white;
    top: 0;
    margin-top: 2rem;
  }
  &__required {
    font-size: 12px;
  }
}

.hasError {
  border-color: red;
}
